import { render, staticRenderFns } from "./UserSettings_ProfileEdit.vue?vue&type=template&id=c4c4b79c&"
import script from "./UserSettings_ProfileEdit.vue?vue&type=script&lang=js&"
export * from "./UserSettings_ProfileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports